export default __webpack_public_path__ + "static/media/youtube_home_big.cc97d1de.png";